export default __webpack_public_path__ + "images/ba1a82670308338493e99f9694fb8293-federal_government.jpg";